module.exports = __webpack_public_path__ + "static/media/chart-pie.f1a73d68.svg";